import { compose, withProps } from 'recompose';
import { max } from 'lodash';
import { LOCATIONS_ALL_ID } from '../constants';

const withMinInterval = compose(
  withProps((props) => {
    if (props.selectedLocation === LOCATIONS_ALL_ID) {
      return {
        minInterval: max(props.barberShops.map(shop => shop.minInterval)),
      };
    }

    return {
      minInterval: (props.barberShops.find(shop => shop.id === props.selectedLocation) || {}).minInterval,
    };
  })
);

export default withMinInterval;
